import Head from "next/head";

const FAQPageSchema = () => {
  return (
    <Head>
      <script
        id="FAQPageSchema"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "आपका पोलिंग बूथ कौन सा है? ऐसे जानें",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "अगर आप अपने पोलिंग बूथ की जानकारी पाना चाहते हैं तो इसके लिए आपको चुनाव आयोग की आधिकारिक वेबसाइट https://electoralsearch.in पर जाना होगा. वेबसाइट पर जाकर सबसे पहले आपको अपना राज्य चुनना होगा, फिर अपनी संसदीय सीट और विधानसभा क्षेत्र का चयन करना होगा. इसके बाद स्क्रीन पर आपके पोलिंग बूथ की लोकेशन और अन्य जरूरी डिटेल दिखाई देंगे.",
                },
              },
              {
                "@type": "Question",
                name: "मेरे निर्वाचन क्षेत्र में कौन-कौन चुनाव लड़ रहा है?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "यदि आप यह जानना चाहते हैं कि आपके निर्वाचन क्षेत्र से इस बार कौन-कौन उम्मीदवार चुनाव लड़ रहे हैं, तो इसके लिए आपको राष्ट्रीय मतदाता पंजीकरण पोर्टल https://voters.eci.gov.in/Homepage पर जाकर अपना नाम, जन्मतिथि और पता दर्ज करना होगा. वहां से आपको उम्मीदवारों की सूची, निर्वाचन क्षेत्र की जानकारी और अन्य चुनावी विवरण मिल जाएंगे.",
                },
              },
              {
                "@type": "Question",
                name: "क्या एक व्यक्ति दो जगहों पर वोटर लिस्ट में नाम दर्ज करवा सकता है?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "नहीं, एक मतदाता एक समय पर सिर्फ एक ही निर्वाचन क्षेत्र में वोटर लिस्ट में अपना नाम दर्ज करा सकता है. दो अलग-अलग स्थानों या राज्यों से नाम दर्ज करवाना कानूनन गलत है और इसे लोक प्रतिनिधित्व अधिनियम, 1950 की धारा 31 के तहत दंडनीय अपराध माना जाता है.",
                },
              },
              {
                "@type": "Question",
                name: "फॉर्म 6, 6A, 8 और 8A का क्या महत्व है?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "चुनाव आयोग ने वोटरों की सुविधा के लिए विभिन्न फॉर्म निर्धारित किए हैं. फॉर्म 6 उन नए मतदाताओं के लिए है जो 18 वर्ष की आयु पूरी कर चुके हैं और पहली बार पंजीकरण कराना चाहते हैं. वहीं फॉर्म 6A उन भारतीय नागरिकों के लिए है जो विदेश में रहते हैं, लेकिन भारत में वोट डालना चाहते हैं. फॉर्म 8 का उपयोग मतदाता सूची में सुधार के लिए किया जाता है, जैसे कि नाम, फोटो, पता या जन्मतिथि में संशोधन. यदि कोई वोटर अपने निर्वाचन क्षेत्र में घर बदलते हैं तो उसमें बदलाव करने के लिए फॉर्म 8A भरना होता है.",
                },
              },
              {
                "@type": "Question",
                name: "मतदाता सूची में नाम है या नहीं, कैसे जांचें?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "मतदाता सूची में अपना नाम देखने के लिए आप https://electoralsearch.in वेबसाइट पर जा सकते हैं. यदि आपका नाम सूची में मौजूद है तो आप मतदान के लिए पात्र हैं. यदि नहीं, तो आपको https://www.nvsp.in पर जाकर पुनः पंजीकरण करना होगा. इसके अलावा आप 'Voter Helpline' ऐप का इस्तेमाल करके भी यह जानकारी प्राप्त कर सकते हैं.",
                },
              },
              {
                "@type": "Question",
                name: "क्या आधार कार्ड दिखाकर वोट डाल सकते हैं?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "अगर आपका नाम वोटर लिस्ट में दर्ज है तो आप मतदान वाले दिन आधार कार्ड को पहचान प्रमाण के रूप में दिखाकर मतदान कर सकते हैं. यानी आधार कार्ड से आप वोट डाल सकते हैं, लेकिन यह जरूरी है कि आपका नाम मतदाता सूची में हो.",
                },
              },
              {
                "@type": "Question",
                name: "ऑफलाइन वोटर रजिस्ट्रेशन कैसे करें?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "यदि आप ऑफलाइन माध्यम से वोटर रजिस्ट्रेशन कराना चाहते हैं तो इसके लिए आपको फॉर्म 6 की दो प्रतियां भरनी होंगी. यह फॉर्म आपको बूथ लेवल ऑफिसर, चुनाव पंजीकरण अधिकारी या उप-चुनाव पंजीकरण अधिकारी से मिलेगा. फॉर्म भरने के बाद आपको आवश्यक दस्तावेजों के साथ इसे संबंधित अधिकारी को जमा करना होगा.",
                },
              },
              {
                "@type": "Question",
                name: "छात्र-छात्राएं जो अपने घर से दूर रहते हैं, वे कैसे वोट डालें?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "जो विद्यार्थी हॉस्टल या किराए के कमरे में रहते हैं वे उस पते को आधार बनाकर वोटर लिस्ट में नाम जुड़वा सकते हैं. इसके लिए फॉर्म 6 भरते समय अपने संस्थान के प्रमुख जैसे प्रिंसिपल, रजिस्ट्रार या डीन से प्रमाणपत्र लेना होगा. यह प्रमाणपत्र Annexure II के तहत चुनाव आयोग की वेबसाइट से लिया जा सकता है.",
                },
              },
              {
                "@type": "Question",
                name: "क्या बेघर व्यक्ति का नाम भी वोटर लिस्ट में जुड़ सकता है?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "जी हां, अगर कोई व्यक्ति बेघर है तो भी वह मतदाता सूची में नाम जुड़वा सकता है. उसके स्थायी पते की जरूरत नहीं होती, केवल इतना जरूरी है कि बूथ लेवल ऑफिसर यह सत्यापित करे कि वह व्यक्ति किस स्थान पर निवास करता है.",
                },
              },
              {
                "@type": "Question",
                name: "ईवीएम (EVM) क्या है और कैसे काम करती है?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "ईवीएम यानी इलेक्ट्रॉनिक वोटिंग मशीन का उपयोग मतदान और मतगणना दोनों के लिए किया जाता है. यह दो भागों में होती है, पहला कंट्रोल यूनिट और दूसरा बैलेटिंग यूनिट. ये दोनों एक साथ तार से जुड़ा हुआ होता है जिसका कंट्रोल यूनिट पोलिंग ऑफिसर के पास होता है. इस मशीन पर पार्टी के चिह्न और उम्मीदवारों के नाम होते है. मतदाता अपनी पसंद के उम्मीदवार के सामने लगे बटन को दबाकर अपना वोट डालता है.",
                },
              },
              {
                "@type": "Question",
                name: "EVM और VVPAT से मतों की गिनती कैसे होती है?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "गिनती की प्रक्रिया सबसे पहले पोस्टल बैलेट से शुरू होती है. इसके लगभग आधे घंटे बाद EVM से प्राप्त वोटों की गिनती की जाती है. EVM से जुड़े प्रत्येक बूथ की कंट्रोल यूनिट को खोला जाता है और रिजल्ट बटन दबाकर उसमें दर्ज वोटों को पढ़ा जाता है. एक बार में अधिकतम 14 ईवीएम की गिनती की जाती है. साथ ही उससे जुड़े VVPAT की पर्चियों से भी इन आंकड़ों का मिलान किया जाता है और रिटर्निंग ऑफिसर को भेज दिया जाता है.",
                },
              },
              {
                "@type": "Question",
                name: "यदि EVM खराब हो जाए तो क्या किया जाता है?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "किसी पोलिंग बूथ पर EVM में गड़बड़ी होने पर उसे तुरंत एक वैकल्पिक मशीन से बदल दिया जाता है. EVM की मेमोरी में वोट पहले से सुरक्षित रहते हैं, इसलिए डाले गए वोटों पर कोई असर नहीं पड़ता. अंतिम गिनती में दोनों मशीनों का मिलान किया जाता है.",
                },
              },
              {
                "@type": "Question",
                name: "पोस्टल बैलट से वोटिंग कैसे की जाती है?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "पोस्टल बैलट का उपयोग वही व्यक्ति कर सकता है जो सेना में कार्यरत हो, चुनाव ड्यूटी पर तैनात हो या किसी कारणवश राज्य से बाहर हो. इसके अतिरिक्त, किसी व्यक्ति को यदि एहतियातन हिरासत में लिया गया है, तो वह भी पोस्टल बैलट से वोट डाल सकता है.",
                },
              },
              {
                "@type": "Question",
                name: "नोटा (NOTA) क्या है और इसका क्या प्रभाव होता है?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: `NOTA यानी "इनमें से कोई नहीं" एक ऐसा विकल्प है जिससे मतदाता यह संकेत दे सकता है कि वह किसी भी उम्मीदवार को उपयुक्त नहीं मानता. यह विकल्प पहली बार अक्टूबर 2013 में लागू हुआ था. 2015 के विधानसभा चुनाव में, बिहार में सबसे अधिक 2.48 प्रतिशत NOTA वोट दर्ज किए गए, उसके बाद 2017 के गुजरात विधानसभा चुनाव में 1.8 प्रतिशत वोट दर्ज किए गए. 2023 में पांच राज्यों के विधानसभा चुनावों में, छत्तीसगढ़ में सबसे अधिक 1.29 प्रतिशत नोटा वोट दर्ज किए गए. हालांकि अगर NOTA को सबसे अधिक वोट मिलें तो भी सबसे ज्यादा वोट पाने वाले उम्मीदवार को विजेता घोषित किया जाता है.`,
                },
              },
              {
                "@type": "Question",
                name: "निर्वाचक पंजीकरण अधिकारी से कोई शिकायत है तो क्या करें?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: " यदि किसी मतदाता को निर्वाचक पंजीकरण अधिकारी के कामकाज या निर्णय को लेकर कोई शिकायत है, तो वह इसे कई स्तरों पर दर्ज करा सकता है. सबसे पहले यह शिकायत संशोधन अवधि के दौरान जिला चुनाव अधिकारी के समक्ष की जा सकती है. इसके पश्चात यह शिकायत जिलाधिकारी, अपर जिलाधिकारी, कार्यकारी मजिस्ट्रेट या संबंधित जिले के जिला कलेक्टर के पास भेजी जाती है. अंततः यदि कोई मतदाता अपीलीय प्राधिकरण के आदेश से असंतुष्ट है, तो वह राज्य के मुख्य निर्वाचन अधिकारी के समक्ष अपील कर सकता है.",
                },
              },
              {
                "@type": "Question",
                name: "चुनाव के दौरान किसी भी गड़बड़ी के दिखने पर क्या करें?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "सबसे पहले तो गड़बड़ी दिखने पर उसे इग्नोर  न करें, बल्कि उसकी शिकायत करें. इसके लिए आप ऑनलाइन भी इसकी शिकायत दर्ज कर सकते हैं. इसके लिए चुनाव आयोग का पोर्टल https://eci-citizenservices.eci.nic.in/default.aspx उपलब्ध है, जहां शिकायत दर्ज करने के बाद आपको एक ट्रैकिंग आईडी मिलती है. इस आईडी के माध्यम से आप अपनी शिकायत की स्थिति https://eci-citizenservices.eci.nic.in/trackstatus.aspx पर जाकर देख सकते हैं. इसके अलावा आप complaints@eci.gov.in पर ईमेल के माध्यम से भी शिकायत भेज सकते हैं.",
                },
              },
              {
                "@type": "Question",
                name: "एग्जिट पोल क्या होता है और इसकी शुरुआत कब हुई थी?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "एग्जिट पोल एक सर्वेक्षण तकनीक है जिसमें मतदान के दिन जब मतदाता पोलिंग बूथ से बाहर निकलता है, तो उससे पूछा जाता है कि उसने किसे वोट दिया. इस तरह एकत्र किए गए आंकड़ों के आधार पर अनुमान लगाया जाता है कि किस उम्मीदवार या दल को कितनी सीटें मिल सकती हैं. भारत में एग्जिट पोल के नतीजे मतदान के अंतिम चरण के दिन ही सार्वजनिक किए जा सकते हैं. इसकी शुरुआत सबसे पहले नीदरलैंड्स में 15 फरवरी 1967 को मार्सेल वॉन डैम ने की थी, जबकि भारत में इसका श्रेय इंडियन इंस्टीट्यूट ऑफ पब्लिक ओपिनियन के प्रमुख एरिक डी कोस्टा को जाता है.",
                },
              },
              {
                "@type": "Question",
                name: "पोस्ट पोल सर्वे क्या है और यह एग्जिट पोल से कैसे अलग है?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "पोस्ट पोल सर्वे भी एक प्रकार का सर्वे है, जिसे मतदान के तुरंत बाद नहीं, बल्कि एक या दो दिन बाद किया जाता है. इसमें उन मतदाताओं से संपर्क किया जाता है जिन्होंने हाल ही में मतदान किया है, और उनसे उनके चुनावी रुझान को लेकर सवाल पूछे जाते हैं. उदाहरण के लिए, यदि किसी चरण की वोटिंग 23 अप्रैल को हुई है, तो 24 या 25 अप्रैल को मतदाताओं से बात कर उनकी राय ली जाती है. यह प्रक्रिया अधिक सटीक मानी जाती है क्योंकि मतदाता को सोचने और निष्पक्ष रूप से जवाब देने का समय मिलता है.",
                },
              },
              {
                "@type": "Question",
                name: "ओपिनियन पोल क्या होता है और इसकी सैंपलिंग कैसे की जाती है?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "ओपिनियन पोल चुनाव से पहले किया जाने वाला सर्वेक्षण होता है जिसमें मतदाताओं की राय जानने की कोशिश की जाती है कि वे किस पार्टी या उम्मीदवार को वोट देना चाहेंगे. यह आमतौर पर पत्रकारों और रिसर्च एजेंसियों द्वारा कराया जाता है. इसकी शुरुआत जॉर्ज गैलप और क्लॉड रॉबिंसन ने की थी. इस पोल के लिए फील्ड वर्क बेहद जरूरी होता है जिसमें एजेंसी के कर्मचारी मतदाताओं से आमने-सामने बात करते हैं, फॉर्म भरवाते हैं और उनकी पहचान गुप्त रखते हैं. सीलबंद डिब्बों में मतदाता अपनी राय डालते हैं जिससे निष्पक्षता बनी रहती है. ओपिनियन पोल में सबसे जरूरी प्रक्रिया होती है सैंपलिंग यानी किन लोगों से, किन इलाकों में और किन सामाजिक पृष्ठभूमि से राय ली जा रही है.",
                },
              },
              {
                "@type": "Question",
                name: "आदर्श आचार संहिता क्या होती है और यह कब लागू होती है?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "आदर्श आचार संहिता चुनाव आयोग द्वारा तय किया गया दिशा-निर्देशों का ऐसा सेट होता है जिसका पालन सभी राजनीतिक दलों, उम्मीदवारों और सरकारी अधिकारियों को करना होता है. इसका उद्देश्य चुनाव प्रक्रिया को निष्पक्ष और पारदर्शी बनाना है. इसमें सरकारी योजनाओं की घोषणाओं पर रोक, मतदाताओं को प्रभावित करने वाले किसी भी कार्य पर प्रतिबंध, और सार्वजनिक संसाधनों के दुरुपयोग को रोकना शामिल होता है. जैसे ही चुनाव की तारीखों की घोषणा होती है, आचार संहिता स्वतः प्रभाव में आ जाती है.",
                },
              },
              {
                "@type": "Question",
                name: "क्या सांसद विधानसभा चुनाव लड़ सकते हैं?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "हां, भारत का कोई भी सांसद विधानसभा चुनाव लड़ सकता है, लेकिन अगर वह दोनों स्थानों से जीत जाता है तो उसे विधानसभा चुनाव परिणाम आने के 14 दिनों के भीतर किसी एक पद से इस्तीफा देना अनिवार्य होता है. यदि वह ऐसा नहीं करता है, तो विधानसभा में उसकी सदस्यता स्वतः समाप्त हो जाएगी. भारत में कोई व्यक्ति एक साथ दो निर्वाचित पदों पर कार्य नहीं कर सकता.",
                },
              },
              
            ],
          }),
        }}
      />
    </Head>
  );
};

export default FAQPageSchema;
